import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";

import roofingContractorLA from "../content/blog/roofing-contractor-los-angeles";
import solarCostCA from "../content/blog/solar-panel-installation-cost-california-2026";
import landscapingLA from "../content/blog/landscaping-contractor-los-angeles";
import hvacCA from "../content/blog/hvac-repair-cost-california";
import plumberLA from "../content/blog/plumber-los-angeles";
import roofingPasadena from "../content/blog/roofing-contractor-pasadena";
import landscapingLongBeach from "../content/blog/landscaping-services-long-beach";
import solarGlendale from "../content/blog/solar-installation-glendale";
import hvacSantaMonica from "../content/blog/hvac-repair-santa-monica";
import plumberBurbank from "../content/blog/plumber-burbank";
import plumberPasadena from "../content/blog/plumber-pasadena";
import roofingLongBeach from "../content/blog/roofing-contractor-long-beach";
import electricianLA from "../content/blog/electrician-los-angeles";
import landscapingGlendale from "../content/blog/landscaping-glendale";
import solarLongBeach from "../content/blog/solar-panels-long-beach";
import hvacBurbank from "../content/blog/hvac-contractor-burbank";
import roofingSantaMonica from "../content/blog/roofing-contractor-santa-monica";
import electricianPasadena from "../content/blog/electrician-pasadena";
import plumberGlendale from "../content/blog/plumber-glendale";
import landscapingBurbank from "../content/blog/landscaping-burbank";
import roofingTorrance from "../content/blog/roofing-contractor-torrance";
import solarInglewood from "../content/blog/solar-installation-inglewood";
import landscapingTorrance from "../content/blog/landscaping-contractor-torrance";
import electricianInglewood from "../content/blog/electrician-inglewood";
import roofingRedondoBeach from "../content/blog/roofing-contractor-redondo-beach";
import roofingManhattanBeach from "../content/blog/roofing-contractor-manhattan-beach";
import solarArcadia from "../content/blog/solar-installation-arcadia";
import plumberTorrance from "../content/blog/plumber-torrance";
import electricianLongBeach from "../content/blog/electrician-long-beach";
import hvacPasadena from "../content/blog/hvac-contractor-pasadena";

const POSTS = {
  [roofingContractorLA.slug]: roofingContractorLA,
  [solarCostCA.slug]: solarCostCA,
  [landscapingLA.slug]: landscapingLA,
  [hvacCA.slug]: hvacCA,
  [plumberLA.slug]: plumberLA,
  [roofingPasadena.slug]: roofingPasadena,
  [landscapingLongBeach.slug]: landscapingLongBeach,
  [solarGlendale.slug]: solarGlendale,
  [hvacSantaMonica.slug]: hvacSantaMonica,
  [plumberBurbank.slug]: plumberBurbank,
  [plumberPasadena.slug]: plumberPasadena,
  [roofingLongBeach.slug]: roofingLongBeach,
  [electricianLA.slug]: electricianLA,
  [landscapingGlendale.slug]: landscapingGlendale,
  [solarLongBeach.slug]: solarLongBeach,
  [hvacBurbank.slug]: hvacBurbank,
  [roofingSantaMonica.slug]: roofingSantaMonica,
  [electricianPasadena.slug]: electricianPasadena,
  [plumberGlendale.slug]: plumberGlendale,
  [landscapingBurbank.slug]: landscapingBurbank,
  [roofingTorrance.slug]: roofingTorrance,
  [solarInglewood.slug]: solarInglewood,
  [landscapingTorrance.slug]: landscapingTorrance,
  [electricianInglewood.slug]: electricianInglewood,
  [roofingRedondoBeach.slug]: roofingRedondoBeach,
  [roofingManhattanBeach.slug]: roofingManhattanBeach,
  [solarArcadia.slug]: solarArcadia,
  [plumberTorrance.slug]: plumberTorrance,
  [electricianLongBeach.slug]: electricianLongBeach,
  [hvacPasadena.slug]: hvacPasadena,
  "5-things-before-roofing": {
    category: "Roofing · Homeowners",
    title: "5 things to do before you start a roofing project",
    readTime: "4 min read",
    sections: [
      {
        heading: "1. Take clear photos of the existing roof",
        body: "Walk around the house from the ground and take photos from all sides. Capture close-ups of any obvious damage, sagging areas, or previous patch work. Good photos help you compare before-and-after and make it easier to explain the project clearly during intake.",
      },
      {
        heading: "2. Confirm the contractor's license and insurance",
        body: "Ask for their license number and proof of liability and workers' compensation insurance. In most states you can verify a license online. If something goes wrong and there is no insurance, you may be the one holding the bag.",
      },
      {
        heading: "3. Get a written scope of work (not just a price)",
        body: "The quote should spell out what is included: tear-off, underlayment type, ventilation, flashing, wood replacement, and cleanup. A one-line price with no details is a red flag.",
      },
      {
        heading: "4. Talk about permits and inspections",
        body: "Ask who will pull the permit and how inspections will work in your city. If a contractor avoids permits, that's a sign to slow down and get more information.",
      },
      {
        heading: "5. Clarify cleanup and protection",
        body: "Roof work is messy. Ask how they protect landscaping, where the dumpster will sit, and how they handle nails in the yard and driveway. This should be in writing so there are no misunderstandings.",
      },
    ],
  },
  "is-your-roof-ready-for-solar": {
    category: "Solar · Roof Prep",
    title: "Is your roof ready for solar panels?",
    readTime: "3 min read",
    sections: [
      {
        heading: "1. Check the age and condition of your roof",
        body: "If your roof is near the end of its life, it often makes sense to replace or repair it before adding solar. Otherwise you may pay extra to remove and reinstall panels later just to fix the roof underneath.",
      },
      {
        heading: "2. Look at shade and roof layout",
        body: "Big trees, chimneys, and awkward roof angles can affect solar production. A good installer will model this for you, but you can start by noticing where the sun hits your roof during the day.",
      },
      {
        heading: "3. Ask how roof penetrations will be flashed",
        body: "Solar mounts attach through the roof. Make sure the installer explains how they will waterproof every penetration and what warranty they offer against leaks.",
      },
      {
        heading: "4. Coordinate between roofer and solar installer",
        body: "If different companies handle roofing and solar, ask them to talk to each other. You want compatible materials and a clear plan so each company knows what the other is responsible for.",
      },
    ],
  },
  "small-curb-appeal-upgrades": {
    category: "Landscaping · Curb Appeal",
    title: "Small curb-appeal upgrades that make a big difference",
    readTime: "3 min read",
    sections: [
      {
        heading: "1. Clean edges and fresh mulch",
        body: "Define bed edges, remove weeds, and add a clean layer of mulch. This alone can make a yard look cared-for even without new plants.",
      },
      {
        heading: "2. Simple plant updates, not a full redesign",
        body: "Replace dead or overgrown plants with a few sturdy, low-maintenance options. Focus on the front door area and walkway first.",
      },
      {
        heading: "3. Lighting for safety and style",
        body: "Path lights, a brighter porch light, or simple uplighting on one or two trees can make the home feel safer and more welcoming at night.",
      },
      {
        heading: "4. Think about maintenance",
        body: "Before you add anything, ask how often it needs to be trimmed, watered, or cleaned. A simple plan you can maintain is better than a fancy design that gets ignored.",
      },
    ],
  },
};

export default function BlogPost() {
  const { slug } = useParams();
  const post = POSTS[slug];

  // 🔹 SEO: set title + meta description per article
  useEffect(() => {
    let title = "Post not found | BuildBright Blog";
    let description =
      "The article you are looking for could not be found on the BuildBright blog.";

    if (post) {
      title = `${post.title} | BuildBright Blog`;
      const firstParagraph = post.sections?.[0]?.body || "";
      description =
        firstParagraph.length > 155
          ? firstParagraph.slice(0, 152) + "..."
          : firstParagraph || "Home improvement tips from the BuildBright blog.";
    }

    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, [post]);

  if (!post) {
    return (
      <main className="min-h-screen bg-black text-slate-50">
        <div className="max-w-3xl mx-auto px-4 py-12">
          <h1 className="text-2xl font-bold mb-4">Post not found</h1>
          <p className="mb-4 text-sm text-slate-300">
            The article you&apos;re looking for doesn&apos;t exist or has moved.
          </p>
          <Link
            to="/blog"
            className="text-sm font-semibold text-amber-300 hover:underline"
          >
            ← Back to the BuildBright blog
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-black text-slate-50">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <p className="text-xs font-semibold tracking-[0.2em] text-amber-400 mb-2">
          {post.category}
        </p>
        <h1 className="text-3xl font-bold mb-3 text-slate-50">
          {post.title}
        </h1>
        <p className="text-xs text-slate-400 mb-6">{post.readTime}</p>

        {post.sections.map((section, idx) => (
          <section key={idx} className="mb-6">
            <h2 className="text-lg font-semibold mb-2 text-slate-50">
              {section.heading}
            </h2>
            <p className="text-sm text-slate-300 leading-relaxed">
              {section.body}
            </p>
          </section>
        ))}

        <hr className="my-8 border-slate-800" />

        {/* 🚀 LEAD CAPTURE CTA - REVENUE GENERATION */}
        <div className="bg-gradient-to-br from-amber-600 to-orange-700 rounded-lg p-6 my-8 text-center">
          <h3 className="text-xl font-bold text-white mb-2">
            Ready to connect with vetted contractors?
          </h3>
          <p className="text-amber-100 mb-4 text-sm">
            Get matched with licensed, insured professionals in your area. Submit your project details and receive quotes from qualified contractors.
          </p>
          <Link
            to="/#/get-quotes"
            className="inline-block bg-white text-orange-700 font-semibold px-6 py-3 rounded-lg hover:bg-amber-50 transition-colors text-sm"
          >
            Start Your Project Request →
          </Link>
        </div>

        <p className="text-xs text-slate-400 mb-4">
          These tips are general information only and are not a substitute for
          advice from a licensed contractor, engineer, or other professional.
        </p>

        <Link
          to="/blog"
          className="text-sm font-semibold text-amber-300 hover:underline"
        >
          ← Back to all articles
        </Link>
      </div>
    </main>
  );
}
